import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M2.068 1.184c-.244-.244-.64-.244-.884 0s-.244.64 0 .884l5.933 5.937-5.926 5.931c-.244.244-.244.64 0 .884s.64.244.884 0L8 8.889l5.926 5.931c.244.244.64.244.883 0s.244-.64 0-.884L8.884 8.005l5.933-5.937c.244-.244.244-.64 0-.884s-.64-.244-.884 0L8 7.121 2.068 1.184z"
	})
});
export default SvgClose;
